import { createCustomAction } from 'typesafe-actions';

import { AuthenticationMethod } from '../../utils/Api';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_MEMBER_OFFERS/REQUESTED';
const BLOCKED = '$FETCH_MEMBER_OFFERS/BLOCKED';
const APPROVED = '$FETCH_MEMBER_OFFERS/APPROVED';
const SUCCEEDED = '$FETCH_MEMBER_OFFERS/SUCCEEDED';
const FAILED = '$FETCH_MEMBER_OFFERS/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      locationId?: string;
      promoCode?: string;
      authenticationMethod?: AuthenticationMethod;
      bufferMode?: boolean;
      onlyPromoCode?: boolean;
    }>(type);
};

const success = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      offers: Offer[];
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, success),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
